import "./index.js"; import "./link_to_page.scss"
